module.exports = __webpack_public_path__ + "35de2ccb4b49c29c6afae000d8bfceec.svg";